import { render } from "./DriverCard.vue?vue&type=template&id=3e2a013d&scoped=true"
import script from "./DriverCard.vue?vue&type=script&lang=js"
export * from "./DriverCard.vue?vue&type=script&lang=js"

import "./DriverCard.vue?vue&type=style&index=0&id=3e2a013d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3e2a013d"

export default script